import skutypes from '../../utils/config/skutypes';
import _isArray from 'lodash/isArray';
import eyeshadow from './eyeshadow';
import lipcolor from './lipcolor';
import basic from './basic';

const types = skutypes.getSkuTypes();

const _fromObject = v => {
  switch (v.skuType) {
    case types.eyeshadow.type:
      return eyeshadow.fromDb(v);
    case types.lipcolor.type:
      return lipcolor.fromDb(v);
    case types.blush.type:
    case types.eyelashes.type:
    case types.eyeliner.type:
    case types.foundation.type:
    case types.mascara.type:
    default:
      return basic.fromDb(v);
  }
};

const _fromPageResult = v => ({
  totalSize: v.totalSize,
  results: v.results && !!v.results && v.results.map(vv => _fromObject(vv)),
});

const utils = {
  initSku: (skuType, platformData) => {
    switch (skuType) {
      case types.eyeshadow.type:
        return eyeshadow.initSku(skuType, platformData);
      case types.lipcolor.type:
        return lipcolor.initSku(skuType, platformData);
      case types.blush.type:
      case types.eyelashes.type:
      case types.eyeliner.type:
      case types.foundation.type:
      case types.mascara.type:
      default:
        return basic.initSku(skuType, platformData);
    }
  },
  fromDb: v => (_isArray(v && v.results) ? _fromPageResult(v) : _fromObject(v)),
  toDb: v => {
    switch (v.skuType) {
      case types.eyeshadow.type:
        return eyeshadow.toDb(v);
      case types.lipcolor.type:
        return lipcolor.toDb(v);
      case types.blush.type:
      case types.eyelashes.type:
      case types.eyeliner.type:
      case types.foundation.type:
      case types.mascara.type:
      default:
        return basic.toDb(v);
    }
  },
};

export default utils;
